export function debounce(func, wait = 200, immediate = false) {
    let timeout;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function setDebounce(...props) {
        const later = () => {
            timeout = undefined;
            if (!immediate) {
                func.apply(this, props);
            }
        };
        const canCallNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = window.setTimeout(later, wait);
        if (canCallNow) {
            func.apply(this, props);
        }
    };
}
export function onIntersectionObserver(element, callback, options = {}) {
    const defaultOptions = {
        root: null,
        rootMargin: '0px 0px',
        threshold: 0
    };
    const settings = { ...defaultOptions, ...options };
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                callback();
                observer.unobserve(entry.target);
                observer.disconnect();
            }
        });
    }, settings);
    observer.observe(element);
}
